import Client from '@/repositories/Clients/AxiosClient'
import Config from '@/repositories/Clients/AxiosDefaultConfig'

const resource = `${Config.basePath}`

export default {
  logout() {
    return Client.post(`${resource}/logout`)
  },
  serviceCategoryList() {
    return Client.get(`${resource}/auth/service`)
  },
}
